













































import Vue from 'vue';
import { ValidateFields } from '@/assets/mixins';

import gql from 'graphql-tag';
import { GQLTagRequestObject } from '@/assets/clients/gqlClient';
import { API } from '@lordly/models2/interfaces/gql';

export default Vue.extend({
  name: 'Idea-Page',
  data () {
    return {
      form: {
        idea: '',
      },
      formError: false,
      creatingIdea: false,
      ideaCount: 0,
    };
  },
  // Methods
  methods: {
    async createIdea () {
      // Validate
      let hasError: boolean = !this.validateFields(['idea']);
      // If no errors
      if (!hasError) {
        // Create query
        const query: GQLTagRequestObject = gql`
          mutation ($message: String!) {
            CreateIdea (
              input: {
                message: $message
              }
            ) {
              id
              message
              createdOn
              createdBy
            }
          }
        `;
        // Create variables
        const payload: API.CreateIdeaInput = {
          message: this.form.idea,
        };
        // Perform query
        if (this.ideaCount < 3) {
          // Set loading
          this.creatingIdea = true;
          try {
            await this.$gql.Mutation('CreateIdea', query, payload);
            this.ideaCount++;
            this.form.idea = '';
            (this.$refs['idea'] as Vue & { resetValidation: () => void}).resetValidation();
            this.notify('Thanks, we got your idea!');
          } catch (e) {
            console.error(e);
          } finally {
            this.creatingIdea = false;
          }
        } else {
          this.notify('We like your enthusiasm! But you have reached you idea limit for today! Come back tomorrow?', true);
        }
      } else {
        this.formError = true;
        setTimeout(() => {
          this.formError = false;
        }, 1000);
      }
    },
    validateFields (inputs: string[]) {
      return ValidateFields(this, inputs);
    },
    notify (message: string, error: boolean = false) {
      this.$q.notify({
        message,
        color: (error ? 'red' : 'secondary'),
        position: 'bottom-right',
        timeout: 5000,
        textColor: 'white',
      });
    },
  },
});
